module.exports = __webpack_public_path__ + "static/media/bb.9cb00961.svg";